import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import LearningForumsPage from "./pages/LearningForumsPage";
import ProgramsPage from "./pages/ProgramsPage";
import AdvisoryPage from "./pages/AdvisoryPage";
import ContactPage from "./pages/ContactPage";
import JoinPage from "./pages/JoinPage";
import GalleryPage from "./pages/GalleryPage";
import PartnersPage from "./pages/PartnersPage";
import CareersPage from "./pages/CareersPage";
import NewsletterPage from "./pages/NewsletterPage";

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-gradient-to-br from-white via-slate-50 to-slate-100">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/learning-forums" element={<LearningForumsPage />} />
            <Route path="/learning-forums/:forumId" element={<LearningForumsPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/programs/:programId" element={<ProgramsPage />} />
            <Route path="/advisory-board" element={<AdvisoryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/join" element={<JoinPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/newsletter" element={<NewsletterPage />} />
            {/* Legacy routes redirect */}
            <Route path="/events" element={<LearningForumsPage />} />
            <Route path="/what-we-do" element={<AboutPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
